import React from 'react';
import { createRoot } from 'react-dom/client';

import { FAQAccordion } from '@shared/FAQAccordion';
import { getFaqSchool } from '../main-app/data/faq-school';

// Self-mounting entry pack: create a single React root on #react-faq-accordion
// at DOMContentLoaded and render the FAQ accordion once. Previously this was a
// function component that called createRoot(node) during render, which Suspense
// re-invoked on the same node and produced React's duplicate-createRoot warning.
document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('react-faq-accordion');

  if (!node) return;

  const faqData = {
    schoolName: node.getAttribute('data-school-name'),
    city: node.getAttribute('data-city'),
    street: node.getAttribute('data-street'),
    zipcode: node.getAttribute('data-zipcode'),
    phone: node.getAttribute('data-school-phone'),
    avgRating: node.getAttribute('data-avg-rating'),
    reviewsNumber: node.getAttribute('data-reviews-number'),
    examStatLicenseB: node.getAttribute('data-exam-stat-b'),
    numberOfStudentB: node.getAttribute('data-students-b'),
    examStatYear: node.getAttribute('data-exam-stat-year'),
    licenseCategories: JSON.parse(node.getAttribute('data-license-categories')),
    licenseTags: JSON.parse(node.getAttribute('data-license-tags')),
    hasTimetable: JSON.parse(node.getAttribute('data-has-timetable')),
  };

  const root = createRoot(node);
  root.render(<FAQAccordion faqList={getFaqSchool(faqData)} />);
});
